<template>
    <div v-if="timelineStyle === 1" class="rn-timeline-wrapper timeline-style-one position-relative">
        <div class="timeline-line"/>

        <div class="single-timeline mt--50" v-for="item in 5">
            <div class="timeline-dot">
                <div class="time-line-circle"/>
            </div>
            <div class="single-content">
                <div class="inner">
                    <div class="row row--30 align-items-center">

                        <div class="text-center">
                            <div class="thumbnail" data-aos="fade-up">
                                <img class="radius-small"
                                     :src="require(`@/assets/images/timeline/timeline-0`+item+`.jpg`)"
                                     alt="Corporate Vue Template"/>
                            </div>

<!--                            <div class="video-icon">
                              <Button variant-button-class="rounded-player sm-size"
                                      :is-link="false"
                                      @btnClick="imageIndex = index">
                                <span><Icon :name="timeline.type === 'video' ? 'play' : 'zoom-in'" size="30"/></span>
                              </Button>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>




</template>

<script>
import Icon from "../../components/icon/Icon";
import Button from "../../components/elements/button/Button";
    export default {
        name: 'ProductAfterSalesTimeline',
      components: {Icon,Button},
       props: {
            timelineData: {},
            timelineStyle: {
                type: Number,
                default: 1
            }
        },
        computed: {
            checkTimelineStyle() {
                if (this.timelineStyle === 3) return 'no-gradient';
                else if (this.timelineStyle === 4) return 'dark-line';
                else return '';
            }
        },
      data() {
        return {
          imageIndex: null
        }
      }
    }
</script>